import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { RadioGroup, Box } from '@mui/material'
import type { Theme } from '@mui/material/styles'
import RadioButtonWithLabel from '../partials/RadioButtonWithLabel'

const useStyles = makeStyles()((theme: Theme) => ({
  radioGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
}))

export type RadioSelectContentsProps<T = string> = {
  items: {
    name: T
    label: string
    content?: React.ReactNode
  }[]
  value: T
  onSelect: (value: T) => void
}

/*
ラジオボタンで内容が表示/非表示されるコンポーネント
 */
function RadioSelectContents<T = string>({
  items,
  value,
  onSelect,
}: RadioSelectContentsProps<T>): JSX.Element {
  const { classes } = useStyles()

  return (
    <RadioGroup
      className={classes.radioGroup}
      value={value}
      onChange={(event) => onSelect(event.target.value as T)}
    >
      {items.map(({ name, label, content }) => (
        <Box key={name as string} className={classes.item}>
          <RadioButtonWithLabel value={name as string} label={label} />
          {value === name && content && <Box>{content}</Box>}
        </Box>
      ))}
    </RadioGroup>
  )
}

export default RadioSelectContents
